import React from 'react';
import ReactApexChart from 'react-apexcharts';
import './graficas.css'

class ChartComponent extends React.Component {
  render() {
    const { data, categories, customColors, height,porcentajes } = this.props; 

    const options = {
      series: [
        {
          data: data
        }
      ],
      chart: {
        height: height || 350, 
        type: "bar",
        events: {
          click: function(chart, w, e) {
         
          }
        }
      },
      colors: customColors || [
        "#775DD0",
        "#FF5733",
        "#FFA933",
        "#33FF57",
        "#33AFFF",
        "#FF33A8",
        "#3357FF",
        "#33FFA8",
        "#FF33AF",
        "#A833FF",
        "#33FFC3",
        "#FF33C3",
        "#33C3FF"
      ],
      plotOptions: {
        bar: {
          columnWidth: "37.5%",
          distributed: true,
          borderRadius: 17
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },xaxis: {
        labels: {
          show: false,
        },
        axisTicks: {
          show: false, 
        },
      },  tooltip: {
        custom: function({ series, seriesIndex, dataPointIndex, w }) {
          const color = customColors[dataPointIndex];
          const label = categories[dataPointIndex];
          const value = porcentajes[dataPointIndex]; 

          return (
            '<div className="custom-tooltip" style="width: 155px; font-size: 12px; border-radius: 10%; text-align: center;">' +
            '<div className="tooltip-label" style="background-color: ' +
            color +
            '; color: white; padding: 5px 0;">' +
            label +
            '</div>' +
            '<div className="tooltip-content" style="display: flex; align-items: center; background-color:#dadde9; padding: 5px 10px; background-color:white">' +
            '<div className="sales-circle" style="background-color: ' +
            color +
            '; border-radius: 50%; width: 10px; height: 10px;"></div>' +
            '<div className="sales-value" style="font-weight: bold; margin-left: 5px;">' +
            value + '%' +
            '</div>' +
            '</div>' +
            '</div>'
          );
        },
      },
      toolbar: {
        show: false, 
      },
    };

    return (
      <div id="chart">
        <ReactApexChart options={options} series={options.series} type="bar" height={270} width={450}className="custom-apex-chart"/>
      </div>
    );
  }
}

export default ChartComponent;